import { Component, input } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';

@Component({
  selector: 'app-grid-header',
  templateUrl: './grid-header.component.html',
  styleUrl: './grid-header.component.scss',
  imports: [BaseInlineFormComponent],
})
export class GridHeaderComponent {
  public readonly header = input<string>();
  public readonly fields = input<FormlyFieldConfig[]>();
  public readonly model = input<any>({});
  public readonly labelsVertical = input(false);
}
